module.exports = __webpack_public_path__ + "img/f3.19c23b1f.svg";